import React from 'react'
import AopsBox from '../../../../components/apos/AopsBox'
import SectionHeader from '../../../../components/apos/SectionHeader'
import ContractTable from '../ui/ContractTable'

const ContractSection = ({ contracts, onViewContract }) => {
  return (
    // 1. 부모 div를 flex-column으로 설정하여 내부 요소가 세로로 꽉 차게 함
    <div
      style={{ flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column' }}
    >
      <SectionHeader
        title="인사 전자 계약서 열람"
        subtitle="내 인사정보를 조회할 수 있고 사내 문서를 관리할 수 있어요"
      />
      <AopsBox
        title="전자계약 내역"
        borderBottom={false}
        // 2. 고정 높이(300px) 제거 -> flex: 1로 변경하여 남는 공간을 다 차지하게 함
        style={{ flex: 1, display: 'flex', flexDirection: 'column' }}
        // AopsBox 내부 콘텐츠도 영역을 채우도록 설정 (필요 시)
        bodyStyle={{ flex: 1 }}
      >
        <ContractTable data={contracts} onView={onViewContract} />
      </AopsBox>
    </div>
  )
}

export default ContractSection
